import React from "react"
import {Row,Col} from "react-bootstrap"
import { useNavigate } from 'react-router-dom'


const BladLog = (props) => {
    const nawigacja = useNavigate()
    const login = (dane) =>{
     nawigacja(`/`)
 }
    return(
        <Row>
            <Col  xs={12}><h2>Strona dostępna jest tylko dla uwierzytelnionych użytkowników</h2></Col>
            <Col xs={12}><button className="btn btn-danger" type="input" onClick={login}>Logowanie</button></Col>
        </Row>
        )
}

export default BladLog